import { ImageRegular } from "../styles"

const { default: styled } = require("styled-components")
const { default: minWidth } = require("utils/minWidth")

export const Card = styled.div`
  width: 24.7rem;
  height: 34.9rem;

  margin: 0 0.9rem;

  :first-child {
    margin-left: 0;
  }

  ${minWidth.mobile`
     width:25.3rem;
     height: 35.8rem;
  `}

  background: #faf1ee;
  overflow: hidden;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 1.2rem;
`

export const Logo = styled.div`
  font-size: 1.5rem;
  line-height: 1.1rem;
  font-weight: bold;
  font-family: Monoline, "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #222;
  ${minWidth.mobile`
    font-size: 1.7rem;
    line-height: 1.38rem;
  `}
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0 1.5rem 0;
`
export const ImageContent = styled.div`
  width: 14.2rem;
  height: 13.6rem;
  position: relative;
`
export const ImageOverlay = styled.div`
  position: absolute;
  top: 1rem;
  left: -1rem;
  width: 14.2rem;
  height: 13.6rem;
  background-color: #d44928;
  z-index: 0;
`

export const Image = styled(ImageRegular)`
  width: 14.2rem;
  height: 13.6rem;
  padding-bottom: 142 / 136 * 100;
  border: 0.1rem solid #d44928;
  object-fit: cover;
  z-index: 2;
`

export const Content = styled.div`
  margin-top: 0.5rem;
  padding: 1rem;
`

export const Headline = styled.h3`
  font-weight: 400;
  color: #222222;
  margin-bottom: 1rem;
  font-size: 1.9rem;
  line-height: 2rem;

  ${minWidth.mobile`
    font-size: 1.8rem;
    line-height: 2.4rem;
    margin-bottom: 2rem;
  `}
`

export const AuthorName = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  color: #222222;
  margin-bottom: 0.4rem;
`

export const AuthorRole = styled.div`
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  font-weight: 500;
  color: rgba(34, 34, 34, 0.7);
`
